import { render } from "./terminalConsole.vue?vue&type=template&id=1263f1de&scoped=true"
import script from "./terminalConsole.vue?vue&type=script&lang=js"
export * from "./terminalConsole.vue?vue&type=script&lang=js"

import "./terminalConsole.vue?vue&type=style&index=0&id=1263f1de&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1263f1de"]])

export default __exports__